import { render } from "./NewUserInformationForm.vue?vue&type=template&id=7c52d32c"
import script from "./NewUserInformationForm.vue?vue&type=script&lang=js"
export * from "./NewUserInformationForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/webcrm-develop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__